/** @type {import("@mui/material").SxProps<Theme>} */
import getConfig from 'next/config';
import themes from '../../theme/theme';

// const buttonLargeIndex = themes.components.MuiButton.variants.findIndex((res) => res.props.variant === 'buttonLarge');
const buttonMediumIndex = themes.components.MuiButton.variants.findIndex(
  res => res.props.variant === 'buttonMedium'
);
const buttonSmallIndex = themes.components.MuiButton.variants.findIndex(
  res => res.props.variant === 'buttonSmall'
);

const { publicRuntimeConfig } = getConfig();

const styles = theme => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    maxHeight: { xs: 'auto' },
    m: { xs: '0 auto' },
    // p: { md: 4 },
    backgroundColor: theme.palette.secondary.contrastText,
    maxWidth: '100% !important',
  },
  specContainer: {
    marginLeft: '-1.7rem',
    width: { xs: '100%', md: 'inherit' },
  },
  addOnsContainer: {
    maxWidth: '996px !important',
    margin: '0 auto',
  },
  afterCurveContainer: {
    [theme.breakpoints.down('sm')]: {
      mt: 2,
    },
  },
  imageSlider: {
    swiper: {
      '& .handset-carousel': {
        height: { xs: 'fit-content', md: 500 },
        pb: 6,
        // backgroundColor: theme.palette.primary.lightGrey,
      },
      '& .single-handset': {
        height: { xs: 'fit-content', md: 500 },
        pb: 3.3,
      },
      '& .handset-carousel .swiper-slide , & .single-handset .swiper-slide': {
        width: '100%',
        maxHeight: { xs: 'fit-content', md: 500 },
      },
      '& .handset-carousel .swiper-slide img , & .single-handset .swiper-slide img': {
        width: 'auto',
        height: { xs: 300, md: 500 },
        m: '0 auto',
        display: 'block',
        [theme.breakpoints.down('sm')]: {
          m: '0.8rem auto -0.8rem',
        },
      },
      '& .handset-carousel .swiper-button-next, .handset-carousel .swiper-button-prev , & .single-handset .swiper-button-next, .single-handset .swiper-button-prev':
        {
          bgcolor: theme?.palette?.primary.arrows,
          height: 30,
          width: 30,
          borderRadius: 30,
          '&:after': {
            fontSize: theme.components.MuiButton.variants[buttonSmallIndex].style.fontSize,
            color: theme?.palette?.secondary.errorCTA,
            fontWeight: theme.components.MuiButton.variants[buttonSmallIndex].style.fontWeight,
          },
        },
      '& .handset-carousel .swiper-pagination ,& .single-handset .swiper-pagination ': {
        marginBottom: '4px',
        '& .swiper-pagination-bullet-active': {
          backgroundColor: theme?.palette?.primary.buttonColor,
        },
      },
    },
    swiperIndex: {
      '& .image-selector': {
        maxHeight: 524,
      },
      '& .image-selector .swiper-slide': {
        width: '100%',
        height: 'fit-content ',
      },
      '& .image-selector .swiper-slide img': {
        background: theme.palette.secondary.contrastText,
        width: '50%',
        height: 'auto',
        mb: '0.5rem',
      },
      '& .image-selector .swiper-button-next': {
        bgcolor: theme.palette.secondary.contrastText,
        height: 30,
        width: '90%',
        top: 'unset',
        bottom: 0,
        left: 0,
        right: 0,
        opacity: 0.5,
        '&:after': {
          fontSize: theme.components.MuiButton.variants[buttonMediumIndex].style.fontSize,
          fontWeight: theme.components.MuiButton.variants[buttonMediumIndex].style.fontWeight,
          color: theme?.palette?.secondary.errorCTA,
          transform: 'rotate(90deg)',
        },
      },
      '& .image-selector .swiper-button-prev': {
        bgcolor: theme.palette.secondary.contrastText,
        height: 30,
        width: '90%',
        m: 0,
        top: 0,
        left: 0,
        right: 0,
        opacity: 0.5,
        '&.swiper-button-disabled': {
          display: 'none',
        },
        '&:after': {
          fontSize: theme.components.MuiButton.variants[buttonMediumIndex].style.fontSize,
          fontWeight: theme.components.MuiButton.variants[buttonMediumIndex].style.fontWeight,
          color: theme?.palette?.secondary.dark,
          transform: 'rotate(90deg)',
        },
      },
    },
  },
  colorTitle: {
    color: theme.palette.primary.textColor3,
    marginBottom: '0.5rem',
    display: 'flex',
  },
  storageValue: {
    display: 'flex',
    alignItems: 'flex-end',
    color: theme.palette.primary.textColor3,
  },
  storageSelector: {
    maxHeight: '29px',
    '& .MuiToggleButtonGroup-grouped': {
      borderRadius: '4px',
      backgroundColor: theme.palette.secondary.contrastText,
      border: `0.063rem solid ${theme.palette.primary.textColor3}`,
      '&:hover': {
        backgroundColor: theme.palette.secondary.contrastText,
      },
      '&:not(:first-of-type)': {
        borderRadius: '4px',
        color: theme.palette.secondary.contrastText,
        borderColor: theme.palette.primary.textColor3,
        border: `0.063rem solid ${theme.palette.primary.textColor3}`,
      },
      '&:first-of-type': {
        borderRadius: '4px',
        border: `0.063rem solid ${theme.palette.primary.textColor3}`,
      },
      '&.Mui-disabled': {
        border: `0.063rem solid ${theme.palette.primary.disableCTA}`,
        color: theme.palette.primary.disableCTA,
        backgroundImage: `url(${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}/uploads/Out_Of_Stock_0ebf5451fb.svg)`,
        backgroundColor: theme.palette.primary.contrastText,
        fontFamily: theme.typography.body1.fontFamily,
        fontWeight: theme.typography.body1.fontWeight,
        fontSize: theme.typography.body1.fontSize,
        lineHeight: theme.typography.body1.lineHeight,
        marginRight: '16px',
      },
    },
  },
  storageButton: {
    marginRight: '16px',
    textTransform: 'capitalize',
  },
  brandName: {
    color: theme.palette.secondary.mobileActiveToggleBackground,
  },
  brandModel: {
    color: theme.palette.secondary.mobileActiveToggleBackground,
  },
  brandPriceText: {
    color: theme.palette.primary.textColor3,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  brandPrice: {
    color: theme.palette.primary.textColor3,
  },
  handsetSpecification: {
    color: theme.palette.secondary.mobileActiveToggleBackground,
    textAlign: 'left',
    mt: '0.875rem',
    [theme.breakpoints.down('sm')]: {
      textAlign: 'inherit',
    },
    span: {
      // Important has to be added as information is recieved as dangerouslySetInnerHTML
      [theme.breakpoints.between('md', 'lg')]: {
        overflow: 'hidden !important',
        textOverflow: 'ellipsis !important',
        display: 'block !important',
      },
    },
  },
  specificationDetails: {
    display: 'flex',
    flexDirection: 'row',
    fontSize: '1rem',
    color: theme.palette.primary.contrast,
    justifyContent: 'space-around',
  },
  SecondaryPrequalBannerCurve: {
    width: '100%',
    height: { xs: '2.75rem', sm: '2.875rem', lg: '4rem' },
  },

  specificationTitle: {
    justifyContent: 'left',
    display: 'flex',
    flexDirection: 'row',
    color: theme.palette.primary.main,
  },
  specificationDetailsList: {
    display: 'flex',
    flexDirection: 'row',
    '& li.MuiListItem-padding': {
      paddingLeft: 0,
      paddingBottom: 0,
      paddingTop: 0,
      paddingRight: '1.125rem',
    },
  },
  colorSelector: {
    height: 26.33,
    width: 26.33,
    borderRadius: 30,
    //  p: 0.5,
    marginBottom: 1,
  },
  colorSelectorChange: {
    display: 'block',
    maxWidth: 30,
    minWidth: '100%',
    height: '100%',
    borderRadius: 30,
    border: 'none',
    padding: 0,
    boxShadow: `inset 0px 1px 2px ${theme.palette.primary.boxShadow4Lite}`,
  },
  buttonContainer: {
    p: 4,
    [theme.breakpoints.down('sm')]: {
      pl: 0,
      pr: 0,
      pt: 4,
      pb: 4,
    },
  },
  errorGenricContainer: {
    justifyContent: 'center',
    margin: '10% 50% 0% 50%',
    transform: 'translate(-50%, -50%)',
    [theme.breakpoints.down('md')]: {
      margin: '20% 50% 0% 50%',
      padding: '5%',
    },
    [theme.breakpoints.down('sm')]: {
      margin: '50% 50% 0% 50%',
      padding: '5%',
    },
  },
  errorGenricCode: {
    fontSize: '13.56rem',
    lineHeight: '16.25rem',
    color: theme.palette.secondary.mobileActiveToggleBackground,
    [theme.breakpoints.up('xs')]: {
      fontSize: '9.56rem',
      lineHeight: '11.25rem',
    },
  },
  errorGenricTitle: {
    color: theme.palette.secondary.mobileActiveToggleBackground,
  },
  errorGenricSubtext: {
    color: theme.palette.secondary.mobileActiveToggleBackground,
    margin: '1.5rem 0',
  },
  errorButton: {
    bgcolor: theme.palette.primary.buttonColor,
    color: theme.palette.primary.contrastText,
    width: { xs: '100%', md: 'fit-content' },
    p: '.5rem 2rem',
    marginBottom: '1.5rem',
    borderRadius: 10,
    '&:hover': {
      background: theme.palette.primary.buttonPrimaryHoverColor,
      color: theme.palette.primary.contrastText,
    },
  },
  handsetDetails: {
    maxWidth: 'auto',
    pl: { xs: '0.9rem' },
    pr: { xs: '0.9rem', md: 0 },
  },
  ctaContainer: {
    display: 'flex',
    justifyContent: 'center',
    pl: '1rem',
    mt: '2.5rem',
    mb: '3.75rem',
    [theme.breakpoints.down('sm')]: {
      pl: '1.8rem',
      pr: '1.8rem',
      mt: '2.5rem',
    },
    [theme.breakpoints.between('sm', 'md')]: {
      pl: '2.6rem',
      pr: '1.8rem',
      mt: '2.5rem',
      mb: 0,
      textAlign: 'center',
    },
  },
  addHandsetCtaContainer: {
    display: 'flex',
    justifyContent: 'center',
    pl: '1rem',
    mt: '2.5rem',
    [theme.breakpoints.down('sm')]: {
      pl: '1.8rem',
      pr: '1.8rem',
      mt: '2.5rem',
    },
    [theme.breakpoints.between('sm', 'md')]: {
      pl: '2.6rem',
      pr: '1.8rem',
      mt: '2.5rem',
      mb: 0,
      textAlign: 'center',
    },
  },

  addchangeHandsetCtaContainer: {
    display: 'flex',
    justifyContent: 'center',
    pl: '1rem',
    m: '2.5rem',
    [theme.breakpoints.down('sm')]: {
      pl: '1.8rem',
      pr: '1.8rem',
      mt: '2.5rem',
    },
    [theme.breakpoints.between('sm', 'md')]: {
      pl: '2.6rem',
      pr: '1.8rem',
      mt: '2.5rem',
      mb: 0,
      textAlign: 'center',
    },
  },

  ctastyle2DisableHandsets: {
    border: `0.063rem solid ${theme.palette.primary.textColor2}`,
    // borderRadius: '10000px',
    width: '13.56rem',
    background: theme.palette.primary.buttonColor,
    color: theme.palette.primary.contrastText,
    // boxShadow: `0px 6px 6px -3px ${theme.palette.primary.boxShadow1Dark},0px 10px 14px 1px ${theme.palette.primary.boxShadow1Medium},0px 4px 18px 3px ${theme.palette.primary.boxShadow1Lite}`,
    '&.Mui-disabled': {
      border: `0.063rem solid ${theme.palette.primary.textColor2}`,
      background: theme.palette.primary.buttonInactiveColor,
      opacity: 0.3,
      color: theme.palette.primary.contrastText,
    },
    '&:hover': {
      border: `0.063rem solid ${theme.palette.primary.textColor2}`,
      background: theme.palette.primary.buttonPrimaryHoverColor,
      color: theme.palette.primary.contrastText,
      // boxShadow: `0px 6px 6px -3px  ${theme.palette.primary.boxShadow}, 0px 10px 14px 1px ${theme.palette.primary.boxShadow}, 0px 4px 18px 3px ${theme.palette.primary.boxShadow}`,
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },

  ctaNext: {
    border: `0.063rem solid ${theme.palette.primary.textColor2}`,
    width: '6.625rem',
    background: theme.palette.primary.buttonColor,
    color: theme.palette.primary.contrastText,
    // boxShadow: `0px 6px 6px -3px ${theme.palette.primary.boxShadow1Dark},0px 10px 14px 1px ${theme.palette.primary.boxShadow1Medium},0px 4px 18px 3px ${theme.palette.primary.boxShadow1Lite}`,
    '&.Mui-disabled': {
      background: theme.palette.primary.buttonInactiveColor,
      border: 'none',
      padding: '0.5rem 1.5rem',
      color: theme.palette.primary.contrastText,
    },
    '&:hover': {
      border: `0.063rem solid ${theme.palette.primary.textColor2}`,
      background: theme.palette.primary.buttonPrimaryHoverColor,
      color: theme.palette.primary.contrastText,
      // boxShadow: `0px 6px 6px -3px  ${theme.palette.primary.boxShadow}, 0px 10px 14px 1px ${theme.palette.primary.boxShadow}, 0px 4px 18px 3px ${theme.palette.primary.boxShadow}`,
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  faqContainerSuperMain: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    paddingBottom: '6rem',
  },
});

export default styles;
